export const uiGrey = {
  "900": "#06090C" as const,
  "850": "#0B1015" as const,
  "800": "#151C25" as const,
  "750": "#1A222B" as const,
  "700": "#212932" as const,
  "650": "#29313A" as const,
  "600": "#343D47" as const,
  "550": "#3F4853" as const,
  "500": "#4E5763" as const,
  "450": "#5B6470" as const,
  "400": "#68717E" as const,
  "350": "#757E8B" as const,
  "300": "#828A97" as const,
  "250": "#9FA6B2" as const,
  "200": "#BAC0CA" as const,
  "150": "#CED2DA" as const,
  "100": "#DFE2E7" as const,
  "050": "#EAECF0" as const,
  "000": "#F4F5F7" as const,
};
export const skiliticsGrey = {};

export const interactBlue = {
  "900": "#004B66" as const,
  "800": "#00688F" as const,
  "700": "#007EAC" as const,
  "600": "#0090C5" as const,
  "500": "#009FDA" as const,
  "400": "#44B9E3" as const,
  "300": "#77CCEB" as const,
  "200": "#A0DBF1" as const,
  "100": "#C4E9F6" as const,
  "000": "#E3F4FA" as const,
};

export const thriveGreen = {
  "900": "#3A5600" as const,
  "800": "#507800" as const,
  "700": "#619100" as const,
  "600": "#6FA600" as const,
  "500": "#7AB800" as const,
  "400": "#99C83B" as const,
  "300": "#B3D66C" as const,
  "200": "#C9E297" as const,
  "100": "#DDECBD" as const,
  "000": "#EEF6DF" as const,
};

export const skiliticsRed = {
  "900": "#650E02" as const,
  "800": "#8E1303" as const,
  "700": "#AB1703" as const,
  "600": "#C41B04" as const,
  "500": "#D91F05" as const,
  "400": "#E77161" as const,
  "300": "#EE9B90" as const,
  "200": "#F3BAB3" as const,
  "100": "#F7D4CF" as const,
  "000": "#FBEBE8" as const,
};

export const skiliticsOrange = {
  "900": "#794800" as const,
  "800": "#A86400" as const,
  "700": "#CA7900" as const,
  "600": "#E68A00" as const,
  "500": "#FF9900" as const,
  "400": "#FFB13D" as const,
  "300": "#FFC773" as const,
  "200": "#FFD69A" as const,
  "100": "#FFE5BF" as const,
  "000": "#FFF2E0" as const,
};

export const misc = {
  teal: "#00DAA7" as const,
  fuchsia: "#DA00A0" as const,
  violet: {
    "900": "#45005B" as const,
    "800": "#5C0078" as const,
    "700": "#7C00A2" as const,
    "600": "#9800C6" as const,
    "500": "#A700DA" as const,
    "400": "#BF4EE1" as const,
    "300": "#C96CE6" as const,
    "200": "#DC8DF4" as const,
    "100": "#E6ABF9" as const,
    "000": "#F7E2FD" as const,
  },
  indigo: "#3A00DA" as const,
  blue: "#0033DA" as const,
};

export const neutral = {
  white: "#FFF" as const,
  black: "#000" as const,
};

export const colors = {
  uiGrey,
  skiliticsGrey,
  interactBlue,
  thriveGreen,
  skiliticsRed,
  skiliticsOrange,
  misc,
  neutral,
} as const;
